// Generated from SVG to Code Figma Plugin

export const Alert = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16ZM12 7C11.5168 7 11.125 7.39173 11.125 7.87497V8C11.125 9.44593 11.1902 11.8036 11.2265 13.0011C11.2391 13.4191 11.5818 13.75 12 13.75C12.4182 13.75 12.7609 13.4191 12.7736 13.0011C12.8098 11.804 12.875 9.44793 12.875 8.00333V7.87498C12.875 7.39173 12.4832 7 12 7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
